import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { SummaryTitleAC } from './AC/SummaryTitle.AC';
import { SummaryTitleOV } from './OV/SummaryTitle.OV';
import { SummaryTitleAP } from './AP/SummaryTitle.AP';
import { SummaryTitleDS } from './DS/SummaryTitle.DS';
import { SummaryTitleOV as SummaryTitleOV_GB } from './OV/GB/SummaryTitle.OV';
import { SummaryTitleStyled } from './SummaryTitleStyled';
import { SC } from '../../styles/theme';

export type TitleProps = SC & {
    isSummary?: boolean;
    isBasket?: boolean;
};

const SummaryTitle = (props: TitleProps) => {
    if (BRAND === 'AC') return <SummaryTitleAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <SummaryTitleOV_GB {...props} /> : <SummaryTitleOV {...props} />;
    if (BRAND === 'AP') return <SummaryTitleAP {...props} />;
    if (BRAND === 'DS') return <SummaryTitleDS {...props} />;
    return <SummaryTitleStyled {...props} />;
};

export default SummaryTitle;
